<div
  data-cy="won_message"
  class="component-container"
  [style.backgroundColor]="config().backgroundColor"
>
  <p
    class="label"
    [style.color]="config().label.color"
    [style.fontFamily]="config().label.fontFamily"
  >
    {{ config().label.text }}
  </p>

  <div class="reward-container">
    @let rewardConfig = config().reward;
    <p
      class="label"
      [style.color]="rewardConfig.label.color"
      [style.fontFamily]="rewardConfig.label.fontFamily"
    >
      {{ rewardConfig.label.text }}
    </p>
    <div
      class="reward-amount"
      [style.color]="rewardConfig.amount.color"
      [style.backgroundColor]="rewardConfig.amount.backgroundColor"
    >
      <span [innerHTML]="amount() | formatReward | safe"></span>
      <img
        [src]="rewardConfig.amount.icon"
        [alt]="rewardConfig.amount.alternativeText"
      />
    </div>
  </div>
</div>
